<template>
  <div>
    <van-cell v-for="(item,index) in list" :key="index" @click="toContractDetails(item)">
        <div class="flex-c-center" v-if="item">
         <div>
            <div class="custName-wrap">
              <div class="custName">
                <van-icon name="bookmark" color="green" />{{ item.custName }}
                <span>
                </span>
              </div>
            </div>
            <div style="color: #1989fa">
              【{{item.businessTypeName}}】
            </div>
            <div>
              <div>
                <van-tag color="#999" style="margin-right: 5px" plain type="primary" v-if="item.templateType">{{ formatHandel('templateType',item.templateType) }}</van-tag>
                <van-tag color="#999" style="margin-right: 5px" plain type="primary" v-if="item.payType">{{ formatHandel('payType',item.payType) }}</van-tag>
                <van-tag color="#999" style="margin-right: 5px" plain type="primary" v-if="item.frameType">{{ formatHandel('frameType',item.frameType) }}</van-tag>
                <van-tag color="#999" plain type="primary" v-if="item.custSource">{{ formatHandel('custSource',item.custSource) }}</van-tag>
              </div>
              <div style="color: #07c160;"><span v-if="item.businessTypeName.indexOf('数字技术') > 0 || item.businessTypeName.indexOf('品牌推广') > 0">合同金额(元)：{{item.contractMoney}}</span>
                <span style="color: #ff976a;margin-left: 5px" v-if="item.allReturnedMoney">回款金额(元)： {{item.allReturnedMoney}}</span></div>
              <div>执行时间：{{ item.startTime }} 至 {{ item.endTime }}</div>
              <div v-if="item.deptName">{{item.deptName}}
                <span style="color: #1989fa;margin-left: 5px;">{{item.userName}}</span></div>
              <div v-if="item.contractStatus == 6">归档日期：{{item.filingDate || '--'}}</div>
              <div>签约日期：{{ item.signTime || '--' }}
                <span style="margin-left: 5px">创建时间： {{ item.createTime.slice(0, item.createTime.length - 9) }}</span></div>
            </div>
          </div>
          <van-icon color="#c1c1c1" name="arrow" size="16" class="arrow-color"  @click="toContractDetails(item)" />

        </div>
      </van-cell>
  </div>
</template>

<script>
import { getDicts } from '@/api/system/dict/data'
export default {
  name: 'ListItem',
  components: {
  },
  data() {
    return {
      dialogShow: false,
      list: this.listData,
      total: this.dataTotal,
      options: {
        templateTypeOptions: [],
        payTypeOptions: [],
        frameTypeOptions: [],
        custSourceOptions: []
        // custLevelOptions: [],
        // unitNatureOptions: []
      }
    }
  },
  watch: {
    listData: function (newVal, oldVal) {
      this.list = newVal
    }
  },
  props: ['listData', 'dictOptions', 'isAdd', 'dataTotal'],
  async created() {
    // 合同模板
    await getDicts('cont_buy_approve_flow_type').then(res => {
      this.options.templateTypeOptions = res.data
    })
    // 框架类型
    await getDicts('frame_type').then(res => {
      this.options.frameTypeOptions = res.data
    })
    // 垫款方式
    await getDicts('buy_pay_type').then(res => {
      this.options.payTypeOptions = res.data
    })
    // 合同状态
    await getDicts('contract_status').then(res => {
      this.options.contractStatusOptions = res.data
    })
    // 客户来源
    await getDicts('cust_source').then(res => {
      this.options.custSourceOptions = res.data
    })
  },
  methods: {
    toContractDetails(item) {
      if (!this.isAdd) {
        this.$emit('todetail', item)
      }
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
  // .y{
  //   display: flex;
  //   align-items: center;
  // }
  // /deep/.van-dialog{
  //   height: 60%;
  // }
  // .editClue /deep/.van-dialog__content {
  //   height: 72%;
  // }
  // .van-notice-bar{
  //     height: 60px;
  //     font-size:16px;
  // }
</style>
